import { render, staticRenderFns } from "./BsCollFromNuList.vue?vue&type=template&id=55b77d9e&scoped=true&"
import script from "./BsCollFromNuList.vue?vue&type=script&lang=js&"
export * from "./BsCollFromNuList.vue?vue&type=script&lang=js&"
import style0 from "./BsCollFromNuList.vue?vue&type=style&index=0&id=55b77d9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b77d9e",
  null
  
)

export default component.exports